// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "clp/blocks/adventure_hero_flexible_slider-index" + ".css";
};